<template lang="pug">
  .form-item
    v-card.py-3.pl-3.pr-1(flat)
      v-row(no-gutters)
        v-col
          v-row(no-gutters)
            v-col(@click="clickEdit")
              div.s1.primary500--text {{ form.name }}
            v-col.shrink
              div.d-flex
                v-btn.mr-2(icon @click="clickShare" small)
                  eva-icon.ma-auto(name="share-outline" width="19" height="18" :fill="$vuetify.theme.themes[$theme].primary700")
                v-menu(:offset-y='true')
                  template(v-slot:activator='{ on }')
                    v-btn(icon v-on="on" small)
                      v-icon(color="primary700" size="22") mdi-dots-vertical
                  v-list(dense)
                    v-list-item(@click="clickEdit")
                      v-list-item-title.s2.basic800--text {{ member.role === 'Admin' ? 'Edit' : 'Custom Link'}}
                    v-list-item(v-if="form.products.length > 1" @click="showSortProductDialog = true")
                      v-list-item-title.s2.basic800--text {{ $t('sort_products') }}
                    v-list-item( @click="clickView")
                      v-list-item-title.s2.basic800--text {{ $t('view_form') }}
                    v-list-item(v-if="member.role === 'Admin'" @click="showDuplicateFormDialog = true")
                      v-list-item-title.s2.basic800--text {{ $t('duplicate_form') }}
                    v-list-item(v-if="member.role === 'Admin'" @click="clickDelete")
                      v-list-item-title.s2.basic800--text {{ $t('Delete') }}
          div.d-flex.mt-1
            div.c1.basic600--text {{ $t('products') }}: {{ form.products.length }}
            v-spacer
            div.c1.basic600--text.mx-1 {{ $t('clicks') }}: {{ form.total_clicks }}
            v-spacer
            div.c1.basic600--text {{ $t('sales') }}: {{ form.total_sales | displayPrice }}

        v-col.shrink.pl-5
          y-switch.ma-0.pa-0(v-if="member.role === 'Admin'" v-model="status" :disabled="statusDisable")

    .modals
      add-wa-form(v-if="showAddWaFormDialog" :open.sync="showAddWaFormDialog" :parentForm.sync="form" :company="company")
      duplicate-form(v-if="showDuplicateFormDialog" :open.sync="showDuplicateFormDialog" :parentForm.sync="form" @duplicated="$emit('duplicated', $event)")
      sort-product(v-if="showSortProductDialog" :open.sync="showSortProductDialog" :form.sync="form" :company="company")
      embed-form-dialog(v-if="openEmbedDialog" :open.sync="openEmbedDialog" :form.sync="form" :company="company")
      y-dialog.white(v-model='openPrintQR' max-width="400px")
        v-card
          v-row.pt-3(no-gutters align="center")
            v-col(cols="8" offset="2" align="center")
              v-chip(color="black" :to="`/print-qr?link=${form.slug}`" target="_blank" link outlined small)
                | {{ $t('print') }}
                v-icon.ml-2(small) mdi-cloud-print-outline
            v-col.pr-3(cols="2" align="center")
              v-btn(icon small @click="openPrintQR = false; shareSheet = false")
                v-icon mdi-close
          v-card(align="center" flat)
            div.d-flex.justify-center.align-center(style="position: absolute; height: 100%; width: 100%")
              img(:src="require('@/assets/images/icon_yezza_qr.png')" style="width: 75px")
            vue-qrcode(:value="getQRLinkURL()" :options="{ width: 270 }")

      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_form') }}
          v-card-text.p2.primary500--text.px-4 {{ $t('delete_form_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

      y-dialog(v-model='generatingShareUrl', hide-overlay persistent width='300')
        v-card(color='primary' dark)
          v-card-text.pt-3
            | {{ $t('generating_share_url') }}...
            v-progress-linear.mb-0.mt-2(indeterminate color='white')

      y-bottom-sheet(v-model='shareSheet' inset max-width="600px")
        v-card.py-4(flat)
          div.mx-6.s2.primary400--text {{ $t('share_url_by') }}
          v-list.pa-0
            v-list-item(@click="shareUrlToSocial('whatsapp')")
              v-list-item-avatar.my-0
                v-icon(color="#455A64" size="24") fab fa-whatsapp
              v-list-item-title.s2.basic1000--text WhatsApp
            v-list-item(@click="shareUrlToSocial('facebook')")
              v-list-item-avatar.my-0
                v-icon(color="#3b5998" size="24") fab fa-facebook
              v-list-item-title.s2.basic1000--text Facebook
            //- v-list-item(@click="shareUrlToSocial('twitter')")
            //-   v-list-item-avatar
            //-     v-icon(color="#00acee") fab fa-twitter
            //-   v-list-item-title Twitter
            //- v-list-item(@click="shareUrlToSocial('instagram')")
            //-   v-list-item-avatar
            //-     v-icon(color="#3f729b") fab fa-instagram
            //-   v-list-item-title Instagram
            v-list-item(v-if="$store.state.subscriptions.feature !== 'personal' && customlinkSlug" @click="copyUrl" v-clipboard:copy="getShareCustomURL()")
              v-list-item-avatar.my-0
                v-icon(size="24") mdi-content-copy
              v-list-item-title.s2.basic1000--text {{ $t('copy_custom_link') }}
                div.c1.primary400--text {{getShareCustomURL()}}
            v-list-item(@click="copyUrl" v-clipboard:copy="getBrandedLinkURL()")
              v-list-item-avatar.my-0
                v-icon(size="24") mdi-content-copy
              v-list-item-title.s2.basic1000--text {{ $t('copy_link') }}
                div.c1.primary400--text {{getBrandedLinkURL()}}
            v-list-item(@click="copyUrl" v-clipboard:copy="getShortLinkURL()")
              v-list-item-avatar.my-0
                v-icon(size="24") mdi-content-copy
              v-list-item-title.s2.basic1000--text {{ $t('copy_short_link') }}
                div.c1.primary400--text {{getShortLinkURL()}}
            v-list-item(@click="openPrintQR = true")
              v-list-item-avatar.my-0
                v-icon(size="24") mdi-qrcode
              v-list-item-title.s2.basic1000--text {{ $t('print_qr_code') }}
            v-list-item(@click="openEmbedDialog = true; shareSheet = false")
              v-list-item-avatar.my-0
                v-icon(size="24") mdi-code-braces
              v-list-item-title.s2.basic1000--text {{ $t('embed_in_website') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AddWaForm from '@/components/dialogs/AddDonationForm.vue'
import SortProduct from '@/components/dialogs/SortProduct.vue'
import DuplicateForm from '@/components/dialogs/DuplicateForm.vue'
import IntelAvatar from '@/components/IntelAvatar.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import EmbedFormDialog from '@/components/dialogs/EmbedFormDialog.vue'

export default {
  name: 'DonationFormItem',
  props: ['parentForm', 'company', 'statusd'],
  components: { AddWaForm, SortProduct, DuplicateForm,  IntelAvatar, VueQrcode, EmbedFormDialog },
  data: () => ({
    isLoading: false,
    openDeleteDialog: false,
    showAddWaFormDialog: false,
    showSortProductDialog: false,
    showDuplicateFormDialog: false,
    generatingShareUrl: false,
    shareSheet: false,
    openShowProducts: false,
    realStatus: null,
    openPrintQR: false,
    openEmbedDialog: false,
    customlinkSlug: null,
    customDomainURL: null
  }),
  computed: {
    ...mapState('user', ['member']),
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    status: {
      set (val) {
        this.realStatus = val
        this.updateForm(val)
      },
      get () {
        if (this.form.status === 'published') {
          return true
        } else {
          return false
        }
      }
    },
    statusDisable () {
      if (this.statusd && !this.realStatus) {
        return true
      } else {
        return false
      }
    },
    linkURL () {
      if (this.customDomainURL) {
        return `https://${this.customDomainURL}/`
      }
      return `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/`
    }
  },
  watch: {
    realStatus (val) {
      this.$emit('status', val)
    },
    status: {
      immediate: true,
      handler (val) {
        this.realStatus = val
      }
    }
  },
  mounted () {
    this.fetchDomain()
    this.fetchCustomLink()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchCustomLink() {
      let url = null
      url = this.member.role === 'Agent' ? `member=${this.member.id}` : 'without_member=true'
      this.$axios.get(`/forms/${this.form.id}/slugs/?${url}`)
        .then(resp => {
          if (resp.data.results.length  > 0) {
            this.customlinkSlug = resp.data.results[0].slug
          }
        })
        .catch(() => {})
    },
    fetchDomain() {
      this.$axios.get(`/domains/?company=${this.company.id}`)
        .then((response) => {
          let domain = response.data.results.filter(f => f.enabled && f.mode.includes(1))
          if (domain.length > 0) {
            this.customDomainURL = `wasap.${domain[0].name}`
          }
        })
        .catch(() =>{})
    },
    getFormURL () {
      return `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}`
    },
    getShareLinkURL () {
      return `WhatsApp Now: ${this.linkURL + this.form.slug}`
    },
    getBrandedLinkURL () {
      return this.linkURL + this.form.slug
    },
    getShareLinkFB () {
      return this.linkURL + this.form.slug
    },
    getShortLinkURL () {
      return `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}`
    },
    getQRLinkURL () {
      return this.linkURL + this.form.slug
    },
    getShareCustomURL () {
      return this.linkURL + this.customlinkSlug
    },
    clickEdit () {
      this.showAddWaFormDialog = true
    },
    clickDelete () {
      this.openDeleteDialog = true
    },
    clickShare () {
      if (this.realStatus) {
        this.shareSheet = true
      } else {
        this.generatingShareUrl = true
        setTimeout(() => {
          this.generatingShareUrl = false
          this.showMessage(['error', this.$t('error_message.please_publish_this_form')])
          this.shareSheet = false
        }, 2000)
      }
    },
    shareUrlToSocial(platform) {
      console.log(platform)
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLinkFB()}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLinkURL())}`, '_blank')
      }
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    clickView () {
      if (this.form.status === 'published') {
        window.open(this.getFormURL())
      }
      window.open(`${this.getFormURL()}/?preview=true`)
    },
    startDelete() {
      this.isLoading = true
      this.axios.patch(`/forms/${this.form.id}/`, { status: 'deleted' })
        .then(() => {
          this.$emit('deleted', this.form)
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateForm (val) {
      let status = ''
      let word = ''
      if (val) {
        status = 'published'
        word = 'Form published successfully.'
      } else {
        status = 'draft'
        word = 'Form changed to draft'
      }
      this.$axios.patch(`/forms/${this.form.id}/`, { status: status})
        .then(() => {
          this.showMessage(['success', word])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
